import LTR from "@brand-icons/ploom/pin-default/pin-default-ltr.svg";

import { iconFactory } from "../iconFactory";

export const PinDefaultIcon = iconFactory("PinDefaultIcon", LTR);
